module.exports = __webpack_public_path__ + "img/sacrificial-sword.ae8ec84c.webp";